import { Tooltip } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';

import EditIcon from '@mui/icons-material/Edit';

import RoundIconButton from '@/components/button/RoundIconButton';
import { t } from '@/utils/lang';

export const columns = ({ setEditData, setModalOpen }: any): GridColDef[] => [
    {
        field: 'serialNumber',
        headerName: 'Seri/Mã',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: ({ row }) => (
            <Tooltip title={row.serialNumber}>{row.serialNumber}</Tooltip>
        ),
    },
    {
        field: 'name',
        headerName: 'Tên',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: (row: any) => (
            <Tooltip title={row.row.name}>{row.row.name}</Tooltip>
        ),
    },
    {
        field: 'partLifeTimeHours',
        headerName: 'Tuổi thọ',
        editable: false,
        sortable: false,
        flex: 1,
        maxWidth: 100,
        renderCell: ({ row }) => (
            <Tooltip title={row.partLifeTimeHours}>
                <span>
                    {row.partLifeTimeHours
                        ? row.partLifeTimeHours + ' ' + t('giờ')
                        : '0'}
                </span>
            </Tooltip>
        ),
    },
    {
        field: 'installingQuantity',
        headerName: 'SL lắp đặt',
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => (
            <Tooltip title={row.installingQuantity}>
                {row.installingQuantity || '0'}
            </Tooltip>
        ),
    },
    {
        field: 'receivedQuantity',
        headerName: 'SL nhận về',
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => (
            <Tooltip title={row.receivedQuantity}>
                {row.receivedQuantity || '0'}
            </Tooltip>
        ),
    },
    {
        field: 'removedQuantity',
        headerName: 'SL thay thế',
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => (
            <Tooltip title={row.removedQuantity}>
                {row.removedQuantity || '0'}
            </Tooltip>
        ),
    },
    {
        field: 'action',
        headerName: 'Hành động',
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => (
            <RoundIconButton
                icon={<EditIcon sx={{ color: '#16B1FF8D' }} />}
                sx={{ border: '1px solid #16B1FF8D' }}
                onClick={() => {
                    setEditData(row);
                    setModalOpen(true);
                }}
            />
        ),
    },
];
